import React, { useEffect, useState, useMemo } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import { isEmpty, find } from "lodash";
import { GlobalSpinner } from "../../../../../global/globalFunctions";
import { getProductData } from "../AddProduct/Product.action";
import { setHeading } from "../../../accounts/account.actions";
import { addPurchaseApi } from "./PurchaseOrder.action";
import { getRestaurantData } from "../AddResturant/Resturant.action";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import Select from "react-select";
import Swal from "sweetalert";
import moment from "moment";


const initialInputField = { inventoryId: "", inventoryLabel: "", availableQuantity: 0, demandedQty: 0, stockPrice: 0, remainingIgp: 0 };
const AddPurchaseOrder = (props) => {
  const [inputField, setInputField] = useState([initialInputField]);
  const [manualPurchaseNumber, setManualPurchaseNumber] = useState("");
  const [purchaseDate, setPurchaseDate] = useState(moment().format("YYYY-MM-DD"));
  const [purchaserName, setPurchaserName] = useState("");
  const [suplierName, setSuplierName] = useState("");
  const [desc, setDesc] = useState("");
  const [retaurantId, setRestaurantId] = useState("");
  const [restaurantName, setRestaurantName] = useState("");

  useEffect(() => {
    props.getProductData();
    props.getRestaurantData();
    props.setHeading("Add PurchaseOrder ");
  }, []);

  const showAlert = (type, msg) => {
    Swal({
      title: type === "success" ? "Success" : "Error",
      text: msg,
      icon: type,
      button: "Ok",
    });
  };

  const SavePurchaseOrder = () => {
    props.addPurchaseApi({
      manualPurchaseNumber,
      purchaseDate,
      purchaserName,
      suplierName,
      description: desc,
      data: inputField,
      retaurantId,
    },
      (msg) => showAlert("success", msg),
      (msg) => showAlert("error", msg));

    setManualPurchaseNumber("");
    setPurchaseDate(moment().format("YYYY-MM-DD"));
    setPurchaserName("");
    setSuplierName("");
    setDesc("");
    setRestaurantName("");
    setInputField([initialInputField]);
  };

  const handleProductChange = (selectedOption, index) => {
    const product = find(props.productDataList, { _id: selectedOption.value });
    const updatedFields = [...inputField];
    updatedFields[index] = {
      ...updatedFields[index],
      inventoryId: selectedOption.value,
      inventoryLabel: selectedOption.label,
      availableQuantity: Number(product?.productBalance || 0),
      stockPrice: Number(product?.purchasePrice || 0),
      demandedQty: 0,
      remainingIgp: 0
    };
    setInputField(updatedFields);
  };

  const handleQuantityChange = (e, index) => {
    const { value } = e.target;
    const updatedFields = [...inputField];
    updatedFields[index] = {
      ...updatedFields[index],
      demandedQty: Number(value),
      remainingIgp: Number(value)
    };
    setInputField(updatedFields);
  };

  const addInput = () => setInputField([...inputField, initialInputField]);

  const removeInput = (index) => {
    const updatedFields = inputField.filter((_, i) => i !== index);
    setInputField(updatedFields);
  };

  const productOptions = useMemo(() => (
    props.productDataList.map(x => ({ value: x._id, label: x.name }))
  ), [props.productDataList]);

  const restaurantOptions = useMemo(() => (
    props.restaurantDataList.map(x => ({ value: x._id, label: x.restaurantName }))
  ), [props.restaurantDataList]);


  return (
    <>
      {props.isFetchingProduct || props.isAddingPurchase ? (
        <GlobalSpinner />
      ) : (
        <Container fluid>
          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Select Company *</b></Form.Label>
                <Select
                  value={restaurantName ? { value: retaurantId, label: restaurantName } : null}
                  placeholder="Select Company"
                  onChange={(e) => {
                    setRestaurantId(e.value);
                    setRestaurantName(e.label);
                  }}
                  options={restaurantOptions}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Date *</b></Form.Label>
                <Form.Control
                  type="date"
                  value={purchaseDate}
                  onChange={(e) => setPurchaseDate(moment(e.target.value).format("YYYY-MM-DD"))}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Purchaser Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  onBlur={(e) => setPurchaserName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col >
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Manual Purchase Number</b></Form.Label>
                <Form.Control
                  type="text"
                  onBlur={(e) => setManualPurchaseNumber(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Suplier Name *</b></Form.Label>
                <Form.Control
                  type="text"
                  value={suplierName}
                  onChange={(e) => setSuplierName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3" controlId="garana">
                <Form.Label><b>Description</b></Form.Label>
                <Form.Control
                  type="text"
                  value={desc}
                  onChange={(e) => setDesc(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          {inputField.map((item, i) => (
            <React.Fragment key={i}>
              <Row>
                <Col>
                  <Form.Group className="mb-3" controlId="garana">
                    <Form.Label><b>Select Product *</b></Form.Label>
                    <Select
                      value={item.inventoryLabel ? { value: item.inventoryId, label: item.inventoryLabel } : null}
                      placeholder="Select Product"
                      onChange={(e) => handleProductChange(e, i)}
                      options={productOptions}
                      isOptionDisabled={(option) => !!find(inputField, (x) => x.inventoryId === option.value)}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3" controlId="garana">
                    <Form.Label><b>Available Quantity</b></Form.Label>
                    <Form.Control
                      disabled
                      value={item.availableQuantity}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3" controlId="garana">
                    <Form.Label><b>Add Quantity *</b></Form.Label>
                    <Form.Control
                      type="number"
                      min={0}
                      value={item.demandedQty}
                      onChange={(e) => handleQuantityChange(e, i)}
                    />
                  </Form.Group>
                </Col>
                <Col style={{ marginTop: "30px" }}>
                  {inputField.length - 1 == i && (
                    <Button
                      title="Click to Add Product"
                      onClick={addInput}
                      style={{ float: "right", color: "white", backgroundColor: '#81ABD3' }}  >
                      <AddIcon />
                    </Button>
                  )}
                  {inputField.length !== 1 && (
                    <Button
                      title="Click to Remove Product"
                      onClick={() => removeInput(i)}
                      style={{ float: "right", color: "white", backgroundColor: '#81ABD3', marginRight: "10px" }} >
                      <RemoveIcon />
                    </Button>
                  )}
                </Col>
              </Row>
            </React.Fragment>
          ))}

          <div className="sendDiv">
            {isEmpty(retaurantId) || isEmpty(purchaseDate) || isEmpty(purchaserName) || isEmpty(suplierName) || inputField.some((fields) => isEmpty(fields.inventoryId) || fields.demandedQty <= 0) ? (
              <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> SAVE </Button>
            ) : (
              <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={SavePurchaseOrder}> SAVE </Button>
            )}
          </div>

        </Container>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getProductData: () => dispatch(getProductData()),
  getRestaurantData: () => dispatch(getRestaurantData()),
  setHeading: (data) => dispatch(setHeading(data)),
  addPurchaseApi: (data, successCb, errorCb) => dispatch(addPurchaseApi(data, successCb, errorCb)),
});

const mapStateToProps = (state) => ({
  isAddingPurchase: state.PurchaseReducer.isAddingPurchase,
  isFetchingProduct: state.ProductReducer.isFetchingProduct,
  productDataList: state.ProductReducer.productDataList,
  restaurantDataList: state.ResturantReducer.restaurantDataList,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddPurchaseOrder);
